import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, shareReplay } from 'rxjs';
import { tap } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { Contact } from '../models/contact';

@Injectable({ providedIn: 'root' })
export class ContactService {
  private contactsCache: Contact[] = [];
  private contactsRequest$: Observable<Contact[]> | null = null;

  constructor(private http: HttpClient) {}

  getContacts(): Observable<Contact[]> {
    if (this.contactsCache.length > 0) {
      return of(this.contactsCache);
    }
    if (!this.contactsRequest$) {
      this.contactsRequest$ = this.http.get<Contact[]>(`${environment.apiUrl}contacts`).pipe(
        tap((data) => { this.contactsCache = data; }),
        shareReplay(1)
      );
    }
    return this.contactsRequest$;
  }

  addContact(contact: { name: string; email: string; phoneNumber: string; title: string; role: string; companyId: string }): Observable<Contact> {
    const url = `${environment.apiUrl}contacts`;
    return this.http.post<Contact>(url, contact).pipe(
      tap((created) => {
        if (created) {
          this.contactsCache = [...this.contactsCache, created];
          this.contactsRequest$ = null;
        }
      })
    );
  }

  patchContactField(id: string, field: string, value: any): Observable<Contact> {
    const url = `${environment.apiUrl}contacts/${id}`;
    const body = { fieldName: field, newValue: value };
    return this.http.patch<Contact>(url, body).pipe(
      tap((updated) => {
        const idx = this.contactsCache.findIndex(c => c.id === id);
        if (idx >= 0 && updated) {
          this.contactsCache[idx] = updated;
        }
      })
    );
  }

  deleteContact(id: string): Observable<any> {
    return this.http.delete(`${environment.apiUrl}contacts/${id}`).pipe(
      tap(() => {
        this.contactsCache = this.contactsCache.filter(c => c.id !== id);
        this.contactsRequest$ = null;
      })
    );
  }
}
